export default __webpack_public_path__ + "static/media/secti_logo.db8b5a66.png";